import styled from 'styled-components'

import { breakpoints, colors } from '@/styles'

export const FilterWrapper = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  color: ${colors.black};
  border: 1px solid ${colors.grey88};
  border-radius: 6px;
  background-color: ${colors.white};
  filter: drop-shadow(0px 1px 3px rgba(0, 0, 0, 0.1))
    drop-shadow(0px 1px 2px rgba(0, 0, 0, 0.06));
  overflow: hidden;
`

export const InnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
`

export const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  background-color: ${colors.grey96};
  padding: 16px 16px 16px 2px;
  border-top: 1px solid ${colors.grey88};
`

export const FilterLabel = styled.label<{ $margin: number; small: boolean }>`
  display: block;
  color: ${colors.black};
  font-weight: 500;
  font-size: 18px;
  margin-bottom: ${props => props.$margin || 20}px;

  @media screen and (max-width: ${breakpoints.ipadMiniMax}) {
    font-size: 14px;
    letter-spacing: -0.2px;
    line-height: 19px;
  }

  ${props =>
    props.small &&
    `
    font-size: 14px;
    line-height: 16px;
    margin: 0;
  `}
`

export const CheckboxSection = styled.div`
  padding: 8px 0;
  display: grid;
  grid-template-columns: repeat(auto-fill, 260px);
  gap: 16px 20px;
`
